import { Progress, Typography } from "antd";
import { RefreshCw } from "lucide-react";
import { ImportRecord } from "@/utils/types/importManagement";

const { Text, Title } = Typography;

interface ProcessingUIProps {
  importDetail: ImportRecord;
}

const ProcessingUI = ({ importDetail }: ProcessingUIProps) => {
  return (
    <div className="space-y-4 py-8 text-center">
      <RefreshCw className="mx-auto animate-spin text-blue-500" size={48} />
      <Title level={4}>Processing Import</Title>
      <Text type="secondary">
        Importing {importDetail.total_rows.toLocaleString()} records. Please
        wait...
      </Text>
      <Progress percent={0} status="active" className="mx-auto max-w-md" />
    </div>
  );
};

export default ProcessingUI;
